// extracted by mini-css-extract-plugin
export var addressFields = "_ql-0";
export var animationContainer = "_ql-1";
export var footer = "_ql-2";
export var lineItems = "_ql-3";
export var modalContent = "_ql-4";
export var orderName = "_ql-5";
export var strong = "_ql-6";
export var warning = "_ql-7";